<template>
  <div
    v-if="isVisible"
    class="home-delivery-world-banner"
  >
    <div class="home-delivery-world-content">
      <div class="home-delivery-world-brand-section">
        <div>
          <img
            class="reelables-logo"
            :src="logo"
            :height="40"
            alt="Reelables logo"
          >
          <div class="home-delivery-world-text">
            <p>
              <strong>Find us at</strong>
            </p>
            <p
              v-if="boothNumber"
              class="booth-text"
            >
              {{ boothNumber }}
            </p>
          </div>
        </div>
        <img
          src="https://www.terrapinn-cdn.com/logos/E11037.gif"
          alt="Home Delivery World 2026 Logo"
          class="home-delivery-world-logo"
        >
      </div>

      <div class="home-delivery-world-actions">
        <p class="find-us-text">
          <strong>Find us at</strong>
        </p>
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'HomeDeliveryWorld2026Banner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped lang="scss">
.home-delivery-world-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #07BAF1 0%, #FFF 75%);
  color: #ffffff;
  padding: 8px;
  border-bottom: 3px solid #FAA619;
  font-family: Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.home-delivery-world-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.home-delivery-world-brand-section {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  > div {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 20px;
  }
}

.home-delivery-world-logo {
  height: 45px; /* Adjust height as needed */
  width: auto;
}

.reelables-logo {
  margin-left: -8px;
}

.home-delivery-world-text p {
  margin: 0;
  font-size: 14px;
}

.details {
  display: block;
  font-size: 12px;
  color: #cbd5e0;
}

.home-delivery-world-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.home-delivery-world-text{
  display: none;
}

.booth-badge {
  background-color: lighten(#FAA619, 20%);
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #d4af37;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .home-delivery-world-logo {
    height: 40px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .home-delivery-world-text p {
    font-size: 12px;
  }
  .home-delivery-world-text {
    display: block;
  }
  .booth-badge, .find-us-text {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
